import React from 'react';
import { MonitorPlay, Zap, Clock } from 'lucide-react';
export function CourseFeaturesSection() {
  return <section className="py-12 bg-slate-900 border-y border-slate-800 px-4" data-id="element-67">
      <div className="max-w-5xl mx-auto" data-id="element-68">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center divide-y md:divide-y-0 md:divide-x divide-slate-800" data-id="element-69">
          <div className="flex flex-col items-center pt-6 md:pt-0 px-4" data-id="element-70">
            <div className="w-16 h-16 bg-blue-950 rounded-2xl flex items-center justify-center mb-4 text-blue-400" data-id="element-71">
              <MonitorPlay className="w-8 h-8" data-id="element-72" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-73">100% práctico</h3>
            <p className="text-slate-400" data-id="element-74">
              Aprendés haciendo, con proyectos reales desde el día uno.
            </p>
          </div>

          <div className="flex flex-col items-center pt-8 md:pt-0 px-4" data-id="element-75">
            <div className="w-16 h-16 bg-blue-950 rounded-2xl flex items-center justify-center mb-4 text-blue-400" data-id="element-76">
              <Zap className="w-8 h-8" data-id="element-77" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-78">
              Acceso inmediato
            </h3>
            <p className="text-slate-400" data-id="element-79">
              Empezá a cursar apenas se procesa tu pago, sin esperas.
            </p>
          </div>

          <div className="flex flex-col items-center pt-8 md:pt-0 px-4" data-id="element-80">
            <div className="w-16 h-16 bg-blue-950 rounded-2xl flex items-center justify-center mb-4 text-blue-400" data-id="element-81">
              <Clock className="w-8 h-8" data-id="element-82" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-83">
              Aprendé a tu ritmo
            </h3>
            <p className="text-slate-400" data-id="element-84">
              Acceso de por vida para ver las clases cuando quieras.
            </p>
          </div>
        </div>
      </div>
    </section>;
}